import { MessageRepository, MessageService } from '@aipb/personal-content/data-access';
import { MessageListComponent } from '@aipb/personal-content/feature-coop';
import { LoadingComponent } from '@aipb/ui/loading';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { startWith } from 'rxjs';

@Component({
  selector: 'fr-coop-messages',
  imports: [CommonModule, MatDialogModule, RouterModule, MessageListComponent, LoadingComponent],
  templateUrl: './coop-messages.component.html',
  styleUrls: ['./coop-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageRepository, MessageService]
})
export class CoopMessagesComponent {
  private repository = inject(MessageRepository);
  messages$ = this.repository.messages$;
  loading$ = this.repository.loading$;
  private messageService = inject(MessageService);
  private transloco = inject(TranslocoService);
  lang$ = this.transloco.langChanges$.pipe(startWith(this.transloco.getActiveLang()));

  constructor() {
    this.repository.setActiveFilters({});
    this.messageService.fetchMessages().subscribe();
  }
}
